import type { RaRecord } from 'react-admin';
import { ClampedText, InlinePair } from '../../shared/listCells';

type LooseRecord = RaRecord & Record<string, unknown>;

const toText = (v: unknown): string | null =>
  typeof v === 'string' && v.trim() !== '' ? v : null;

/**
 * Komórki wyłącznie dla list floty i naczep.
 *
 * Osobno od `cells.tsx`, bo tamte komórki rysuje też karta pojazdu, gdzie
 * miejsca jest dość i dwa piętra (numer nad modelem) czytają się lepiej.
 * Na liście te same dane idą w jednej linii, żeby wiersz był niski.
 */

/**
 * Rocznik z kartoteki klienta. TMS oddaje `0`, gdy roku nie zna — na liście
 * wisiało wtedy „0” (e2e na dev, 28.09.2026). Brak to myślnik, nie liczba.
 */
export function formatVehicleYear(v: unknown): string {
  const year = typeof v === 'string' && v.trim() !== '' ? Number(v) : v;
  return typeof year === 'number' && Number.isInteger(year) && year > 0 ? String(year) : '—';
}

/** Numer rejestracyjny i model w jednej linii; pełna treść w podpowiedzi. */
export const VehicleInlineCell = ({ record }: { record: LooseRecord }) => (
  <InlinePair
    primary={toText(record.registrationNumber) ?? toText(record.name) ?? '—'}
    secondary={toText(record.makeAndModel)}
    maxWidth={{ xs: 220, lg: 260, xl: 340 }}
  />
);

/** Kierowca przypisany w TMS — długie nazwiska skracane, myślnik gdy brak. */
export const DriverInlineCell = ({ record }: { record: LooseRecord }) => {
  const k = record.driver as LooseRecord | undefined;
  const name = k ? [k.name, k.surname].filter(Boolean).join(' ') : null;
  return <ClampedText text={name} maxWidth={{ xs: 160, xl: 240 }} />;
};
